import MobilidadeService from '@/services/MobilidadeService';

export const mobilidade = {
    namespaced: true,
    actions: {
        buscarCongestionamentosPorVia () {
            return MobilidadeService.buscarCongestionamentosPorVia()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
    },
    state: {},
    mutations: {},
};
